export default __webpack_public_path__ + "images/PJ.84a9019.png";